import { MobileModal } from './mobile-modal';
import { ModalPortal } from './modal-portal';
import React from 'react';
import { StyledModal } from './modal.styles';
import { useIsSmallViewportWidth } from '@hqo/react-components-library/dist/viewport';
import { ModalProps } from './modal.interface';
import { SIZE_VARIANTS } from 'shared/consts/consts';

const maxWidthVariants: Record<NonNullable<ModalProps['variant']>, number> = {
  small: 424,
  normal: 612,
  wide: 984,
};

export const Modal = ({
  children,
  onClose: handleClose,
  hideMobileCloseButton,
  variant = SIZE_VARIANTS.NORMAL,
}: ModalProps): JSX.Element => {
  const isSmallViewportWidth = useIsSmallViewportWidth();

  return (
    <ModalPortal>
      {isSmallViewportWidth ? (
        <MobileModal onClose={handleClose} hideMobileCloseButton={hideMobileCloseButton}>
          {children}
        </MobileModal>
      ) : (
        <StyledModal
          opened
          maxWidth={maxWidthVariants[variant]}
          onClose={handleClose}
          dataTestId="modal-window"
          data-cy="modal-window"
          variant={variant}
        >
          {children}
        </StyledModal>
      )}
    </ModalPortal>
  );
};
